export const IconScore = (props: any) => {
  return (
    <svg width="17" height="20" viewBox="0 0 17 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g filter="url(#filter0_d_5241_1767)">
        <path
          d="M8.33268 7.66699L8.6055 3.57477C8.61976 3.36083 8.33303 3.27746 8.23036 3.46569L4.9349 9.50737C4.81374 9.7295 4.97451 10.0003 5.22753 10.0003H8.33268L8.06192 13.791C8.04676 14.0032 8.3295 14.0892 8.43506 13.9045L11.7144 8.16571C11.8414 7.94349 11.6809 7.66699 11.425 7.66699H8.33268Z"
          fill="white"
        />
      </g>
    </svg>
  )
}
